// TokenInfo.js
import React from 'react';
import { Container, Typography, Box, Link } from '@mui/material';

export default function TokenInfo() {
  return (
    <Container maxWidth="md" className="token-info-section">
      <Typography variant="h4" align="center" gutterBottom className="title-glow">
        Token Information
      </Typography>
      <Box className="token-details">
        <Typography variant="body1" className="description-text">
          <strong>Token Name:</strong> The Key Maker (KEYM)
        </Typography>
        <Typography variant="body1" className="description-text">
          <strong>Contract Address:</strong> 43rFhn3AC8nTtTtksbRFWL7psRmUNoAmyizcw7qepump
        </Typography>
        <Typography variant="body1" className="description-text">
          <strong>Token URL:</strong>{' '}
          <Link
            href="https://pump.fun/coin/43rFhn3AC8nTtTtksbRFWL7psRmUNoAmyizcw7qepump"
            target="_blank"
            rel="noopener noreferrer"
            className="token-link"
          >
            Visit KEYM on Pump.fun
          </Link>
        </Typography>
      </Box>
    </Container>
  );
}
